import { SHOW_ASSET_FORM, HIDE_ASSET_FORM, SET_OPTIONS, SHOW_PRINT_LABEL, HIDE_PRINT_LABEL, SHOW_MAINTENANCE, HIDE_MAINTENANCE, SHOW_MAINTENANCE_RECORD, HIDE_MAINTENANCE_RECORD } from './types'

export const showAssetForm = (data) => ({
  type: SHOW_ASSET_FORM,
  data: data
})

export const hideAssetForm = () => ({
  type: HIDE_ASSET_FORM,
})

export const setOptions = (options) => ({
  type: SET_OPTIONS,
  options: options
})

export const showPrintLabel = (data) => ({
  type: SHOW_PRINT_LABEL,
  data: data
})

export const hidePrintLabel = () => ({
  type: HIDE_PRINT_LABEL,
})

export const showMaintenance = (data) => ({
  type: SHOW_MAINTENANCE,
  data: data
})

export const hideMaintenance = () => ({
  type: HIDE_MAINTENANCE,
})

export const showMaintenanceRecord = (data) => ({
  type: SHOW_MAINTENANCE_RECORD,
  data: data
})

export const hideMaintenanceRecord = () => ({
  type: HIDE_MAINTENANCE_RECORD,
})